/** Four-segment Transformax wordmark — gradient on "m" via `.lm-*` in App.css.
 * Lead mark is the infinity graphic (client/public/brand/transformax-infinity.png),
 * sized in CSS to match the cap-height of the wordmark's leading "T" (see .lm-mark). */
export default function Wordmark({ className = 'logo-mark' }) {
  return (
    <div className={className}>
      <img className="lm-mark" src="/brand/transformax-infinity.png" alt="" aria-hidden="true" />
      <span className="lm-a">Trans</span>
      <span className="lm-k">for</span>
      <span className="lm-m">m</span>
      <span className="lm-a">ax</span>
    </div>
  );
}
